import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConsts } from 'src/app/shared/appconsts';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new header
    const clonedRequest = req.clone({
      setHeaders: {
        'RKG-LocationId': `${localStorage.getItem(AppConsts.LocationHeaderKey)}`,
      }
    });

    // Pass the cloned request instead of the original request
    return next.handle(clonedRequest);
  }
}
